/*
 * @Author: 李文 
 * @Date: 2020-10-31 10:09:33 
 * @Last Modified by: 李文
 * 媒体资源列表
 */
import React, { useState, useEffect, useRef } from 'react';
import { Spin, Empty, Pagination, message } from 'antd';
import { Scrollbars } from 'react-custom-scrollbars';
import { getMediaList } from '../../actions/resourceList';
import { connect } from 'react-redux';
//import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import microblog from './images/microBlog.png';
import website from './images/website.png';
import wechat from './images/wechat.png';
import drag from './images/drag.png';
import manager from './images/manager.png';
import original from './images/original.png';
import publish from './images/publish.png';
import tiktok from './images/tiktok.png';
import other from './images/other.png';
import "./index.scss";
import {getXiuMiPlugin} from "../../view/components/editor/Editors";

const ResourceList = (props) => {

    const [list, setList] = useState([]);
    const [loading, setLoading] = useState(true);
    // const [current, setCurrent] = useState(1)
    // const [pageSize, setPageSize] = useState(12)
    // const [total, setTotal] = useState(0)

    // useEffect(() => {
    //     if (props.dataSource.length > 0) {
    //         searchList();
    //     }

    // }, [props.dataSource])

    useEffect(() => {
        searchList();
    }, [])

    // const handlePageChange = (page) => {
    //     if (current !== page)
    //         setCurrent(page)
    // }

    const searchList = () => {
        setLoading(true);
        getMediaList({}, (res) => {
            if (res.status === 200) {
                setLoading(false);
                // let resultData = [];
                // resultData.push(res.data);
                //for (let i = 0; i < res.data.length; i++) {
                   // console.log(i)
                   
                   // resultData.push(Object.assign({}, res.data[i], dealData(res.data[i], props.dataSource)));
               // }

                setList(res.data);
                if(res.data.length === 1){
                    let media = res.data[0];
                    jumpOrigin(media);
                }
            }
        })
    }

    //跳转到 原创稿件
    const jumpOrigin = (item) => {
        //item.code  为媒体code
        if (item.type === 1) {
            // 新闻网 
            // props.history.push(`/view/website/originalManuscript/${item.code}`);
           // props.history.push(`/website/wangzhan/${item.code}/activityStory`);
            props.history.push(`/view/website/contribution/${item.code}`);
        }else if (item.type === 2) {
            // 公众号 
           // props.history.push(`/view/wechat/originalManuscript/${item.code}`);
            props.history.push(`/view/wechat/contribution/${item.code}`);
        }else if (item.type === 3) {
            //微博
            // message.warn('预留接口，暂未开发!')
            props.history.push(`/weibo/weiboIndex/${item.code}/allweibo`);
        }else if(item.type === 5){
            // 抖音
            props.history.push(`/douyin/douyinIndex/${item.code}`);
        } else if (item.type === 6) {
            // 其他媒体
            props.history.push(`/view/otherMedia/originalManuscript/${item.code}`);
        }
    }

    //跳转到 新闻网 管理栏目
    const jumpManage = (item) => {
        props.history.push(`${item.manageUrl}`);
    }

    //跳转到 发布内容
    const jumpPublish = (item) => {
        //  props.history.push(`/view/website/otherMediaContributions/${item.code}`)
        //    if(item.type === 1){
        //        //新闻网
        //    }
        if (item.type === 2) {
            //公众号
            props.history.push(`/view/weChatPublish/${item.code}`);

        }else if(item.type === 3){
            //微博
            //message.warn('预留接口，暂未开发!')
            props.history.push(`/weibo/weiboIndex/${item.code}`);
        }else if(item.type === 5){
            // 抖音
            props.history.push(`/douyin/douyinIndex/${item.code}`);
        }
    }

    const dealData = (item, dataSource) => {
        for (let i = 0; i < dataSource.length; i++) {
            if ((dataSource[i].path).indexOf(item.code) !== -1) {
                if (dataSource[i].sons.length > 0) {
                    for (let j = 0; j < dataSource[i].sons.length; j++) {
                        if (dataSource[i].sons[j].name === '栏目视角') {
                            return getUrl(item, dataSource[i].sons[j].sons);
                        }
                    }
                }
            }
        }
    }

    const getUrl = (item, data) => {
        if (data.length > 0) {
            if (data[0].sons.length > 0) {
                getUrl(item, data[0].sons);
            } else {
                item.manageUrl = data[0].path;
            }
        }
        return item
    }


    const { dataSource } = props;
    let height = window.innerHeight - 70;
    let itemWidth=(window.innerWidth-100*4)/4;

    let isChrome=false;
    if(navigator.userAgent.indexOf('Chrome') >= 0){
    isChrome=true;
   }

    return (
        <>
            <div className="resource-list" style={{ height }}>
                {
                    loading ? <Spin className="center" /> :
                        list && (list.length === 0) ? <Empty className="center" /> :
                            <>
                                <Scrollbars >
                                    <div className="resource-list-content">
                                        {
                                            list.map((item, index) => (
                                                    <div className="item" key={item.code} >
                                                        <div className="line_1" onClick={() => jumpOrigin(item)}>
                                                            <div className="pic">
                                                                <img src={drag} alt="" />
                                                            </div>
                                                        </div>
                                                        <div className="line_2" onClick={() => jumpOrigin(item)}>
                                                            <div className="left">
                                                                <div className="pic">
                                                                    <img src={item.type === 1 ? website : (item.type === 2 ? wechat : (item.type === 3 ? microblog : (item.type === 5 ? tiktok : ( item.type === 6 ? other :  ''))))} alt="" />
                                                                </div>
                                                            </div>
                                                          {
                                                            isChrome? <div className="right">
                                                              <span>{item.name}</span>
                                                              <div style={{overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 3,
                                                                WebkitBoxOrient: "vertical",
                                                                width:itemWidth,
                                                              }} title={item.description}>{item.description}</div>
                                                            </div>: <div className="right">
                                                              <span>{item.name}</span>
                                                              <div style={{overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap',
                                                                width:itemWidth,
                                                              }} title={item.description}>{item.description}</div>
                                                            </div>
                                                          }
                                                        </div>
                                                        <div className="line_3">
                                                            <div onClick={() => jumpOrigin(item)}>
                                                                <img src={original} alt="" />
                                                                <span>原创稿件</span>
                                                            </div>
                                                            {/* <div style={{ display: item.type === 1 ? (item.manageUrl ? 'flex' : 'none') : 'none' }} onClick={() => jumpManage(item)}>
                                                                <img src={manager} alt="" />
                                                                <span>管理栏目</span>
                                                            </div> */}
                                                            <div style={{ display: item.type === 2 ? 'flex' : 'none' }} onClick={() => jumpPublish(item)} >
                                                                <img src={publish} alt="" />
                                                                <span>发布内容</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                            ))
                                        }
                                    </div>
                                    {/* <div className="footer">
                                    <Pagination current={current} pageSize={pageSize} total={total} onChange={handlePageChange} />
                                </div> */}
                                </Scrollbars>
                            </>
                }
            </div>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        dataSource: state.systemReducer.navigateLevel2Data,
    }
}

export default connect(mapStateToProps)(ResourceList)